import React from 'react';

import InternalLink from 'notebook/mediocre/mentions/InternalLink';
import {TypedValue} from 'notebook/tables/typed-values/TypedValueConstants';
import withSelectorLoading from 'registry/schema-field-selector/withSelectorLoading';
import {SchemaFieldSelector, SchemaFieldSelectorOption} from 'schemas/SchemaFieldSelectorConstants';
import {areAllOptionsValid, getSelectorOptions} from 'schemas/tags/SchemaFieldSelectorUtil';

interface SelectorTagValueViewerProps {
  typedValue: TypedValue;
  textValue: string;
  registryId?: string;
  schemaFieldSelectorId?: string | null;
  schemaFieldSelector: SchemaFieldSelector | null;
}

export function SelectorInternalLink({name}: {name: string}): JSX.Element {
  return (
    <span>
      <InternalLink className="chip-container chip--tableCell" internalLink={{name}} />
    </span>
  );
}

/**
 * Viewer for selector tag values.
 */
function SelectorTagValueViewer({
  typedValue,
  textValue,
  schemaFieldSelector,
}: SelectorTagValueViewerProps): JSX.Element | null {
  if (typedValue.type !== 'ft_selector') {
    // This could be a COMPUTED value or some other typed value that was copied in.  In those cases, just
    // show the "textValue" here.
    return <span>{textValue}</span>;
  }
  const schemaFieldSelectorTypedValue = typedValue;
  const schemaFieldSelectorOptionIds = schemaFieldSelectorTypedValue.schemaFieldSelectorOptionIds;
  if (
    !schemaFieldSelector ||
    schemaFieldSelectorOptionIds == null ||
    !areAllOptionsValid(schemaFieldSelectorOptionIds, schemaFieldSelector)
  ) {
    // Some of the option ids are not found in the selector or there is no selector loaded yet. This may be
    // caused by pasting a value from a different column.  In any case, render using the value from the
    // typed value
    return <span>{schemaFieldSelectorTypedValue.value}</span>;
  }
  const selectedOptions = getSelectorOptions(schemaFieldSelectorOptionIds, schemaFieldSelector);
  return (
    <span>
      {selectedOptions.map(({name}: SchemaFieldSelectorOption, i: number) => (
        <SelectorInternalLink name={name} key={i} />
      ))}
    </span>
  );
}

export default withSelectorLoading(
  SelectorTagValueViewer,
  (props: SelectorTagValueViewerProps): string | null => props.schemaFieldSelectorId ?? null
);
